module.exports = __webpack_public_path__ + "img/ball-red.fd8d6a60.png";